import HeroBanner from './components/HeroBanner';
import CategoryNav from './components/CategoryNav';
import HotMovies from './components/HotMovies';
import NewMovies from './components/NewMovies';
import FeatureHighlights from './components/FeatureHighlights';
import LatestArticles from './components/LatestArticles';
import CTASection from './components/CTASection';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroBanner />
        <CategoryNav />
        <HotMovies />
        <FeatureHighlights />
        <NewMovies />
        <CTASection />
        <LatestArticles />
      </main>
      <Footer />
    </>
  );
}